export default __webpack_public_path__ + "static/media/trophy_locked.9fffa128.png";